import { render, staticRenderFns } from "./AgeChart.vue?vue&type=template&id=753ea8a6&"
import script from "./AgeChart.vue?vue&type=script&lang=js&"
export * from "./AgeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports